/** SMS sender status: configured / dry-run / not configured, from `settings.sms`. */
import { AlertTriangle, CheckCircle2, FlaskConical } from 'lucide-react';
import type { SmsStatus } from './types';

export function SmsStatusBanner({ sms }: { sms: SmsStatus }) {
  if (!sms.configured) {
    return (
      <div role="status" className="flex items-start gap-2.5 rounded-xl border border-warning/30 bg-warning-bg px-4 py-3 text-[13px] text-gray-900">
        <AlertTriangle size={16} strokeWidth={2} className="mt-0.5 shrink-0 text-warning" aria-hidden />
        <div>
          <div className="font-medium">Text messaging is not set up yet</div>
          <div className="mt-0.5 text-gray-700">
            The RingCentral sender is missing on the worker. Texts are logged here but nobody receives them until it is added.
          </div>
        </div>
      </div>
    );
  }
  if (sms.dry_run) {
    return (
      <div role="status" className="flex items-start gap-2.5 rounded-xl border border-info-blue/30 bg-info-blue-bg px-4 py-3 text-[13px] text-gray-900">
        <FlaskConical size={16} strokeWidth={2} className="mt-0.5 shrink-0 text-info-blue" aria-hidden />
        <div>
          <div className="font-medium">Dry run: texts are logged, not sent</div>
          <div className="mt-0.5 text-gray-700">
            Every text shows in a candidate's Activity as “Dry run”. Turn off <code className="mono">SMS_DRY_RUN</code> on the worker to send for real
            {sms.from_number ? ` from ${sms.from_number}` : ''}.
          </div>
        </div>
      </div>
    );
  }
  return (
    <div role="status" className="flex items-start gap-2.5 rounded-xl border border-success/30 bg-success-bg px-4 py-3 text-[13px] text-gray-900">
      <CheckCircle2 size={16} strokeWidth={2} className="mt-0.5 shrink-0 text-success" aria-hidden />
      <div>
        <div className="font-medium">Texts are live{sms.from_number ? ` from ${sms.from_number}` : ''}</div>
        <div className="mt-0.5 text-gray-700">Candidates and recipients receive real messages during contact hours.</div>
      </div>
    </div>
  );
}
